import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { translate } from 'react-translate';
import Sidebar from '@containers/Sidebar';
import Header from '@containers/Header';
import ErrorPage from '@containers/ErrorPage';
import Offline from '@components/Offline';
import { GET_PARENTS, GET_CODE_INFORMATION } from '@redux/generic/types';
import Tabs from '../Tabs';
import * as S from './styles';
import { SurveyProvider } from '@utils/contexts';

const Dashboard = (props) => {
  const {
    dispatch,
    match: {
      params: { code },
    },
    t,
    children,
    noSidebar,
    noTabs,
    hideBreadcrumb,
    showButtonCalendar,
    genericReducer: { breadCrumb },
    shouldNotAddMargin = false,
  } = props;

  const [isOnline, setisOnline] = useState(true);

  useEffect(() => {
    if (code === 'root') {
      dispatch({
        type: GET_CODE_INFORMATION.RESET,
      });
      dispatch({
        type: GET_PARENTS.REQUEST,
        version: '1.1',
        code,
      });
      return;
    }

    dispatch({
      type: GET_PARENTS.REQUEST,
      version: '1.1',
      code,
    });

    dispatch({
      type: GET_CODE_INFORMATION.REQUEST,
      version: '1.1',
      code,
    });
  }, [code, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => setisOnline(navigator.onLine), 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <S.DashboardWrapper>
      <S.RouterWrapper>
        <SurveyProvider>
          <Header />

          {isOnline ? (
            <>
              {!breadCrumb.status || breadCrumb.status === 200 ? (
                <>
                  {!noTabs && (
                    <Tabs hideBreadcrumb={hideBreadcrumb} showButtonCalendar={showButtonCalendar} />
                  )}
                  <S.ContentWrapper>
                    {!noSidebar && <Sidebar />}
                    <S.MainWrapper shouldNotAddMargin={shouldNotAddMargin}>
                      {children}
                    </S.MainWrapper>
                  </S.ContentWrapper>
                </>
              ) : (
                <S.MainWrapper shouldNotAddMargin={shouldNotAddMargin}>
                  <ErrorPage {...props} />
                </S.MainWrapper>
              )}
            </>
          ) : (
            <Offline description={t('DESCRIPTION_TEXT')} linkText={t('LINK_TEXT')} />
          )}
        </SurveyProvider>
      </S.RouterWrapper>
    </S.DashboardWrapper>
  );
};

function mapStateToProps(state) {
  return {
    authenticationReducer: state.authenticationReducer,
    genericReducer: state.genericReducer,
  };
}

export default withRouter(connect(mapStateToProps)(translate('DashboardOff')(Dashboard)));
